import React, { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { itemQueryKey } from '../../../../../../api/queries'
import { queryItem } from '../../../../../../api/queries'
import { IItem } from '../../../../../../api/types/item'
import { Item } from '../../../../../ItemsIndex/components/Item/Item'
import { Alert, AlertTitle } from '@mui/material'
import { AxiosError } from 'axios'

interface Props {
  id: number
  onLoad?: any
}

export const ChatItem: React.FC<Props> = ({ id, onLoad }) => {
  const {
    isLoading,
    data: item,
    error,
  } = useQuery<IItem>(itemQueryKey(id), () => queryItem(id), {
    onSuccess: async () => {},
  })

  useEffect(() => {
    onLoad && onLoad()
  }, [isLoading])

  return (
    <>
      {item && (
        <>
          <Item reverseBackground={true} showActions={false} item={item} />
        </>
      )}
      {error && (
        <Alert severity={'error'}>
          <AlertTitle>{(error instanceof AxiosError && error?.response?.status) || ''}</AlertTitle>
          Nie udało się wczytać przedmiotu
        </Alert>
      )}
    </>
  )
}
